import {Check} from "@sparkware/app-utils";
import {StaticArenaGameFilter} from "../filters/static-arena-game-filter";
import {ArenaGameFiltersCategoryBase} from "./arena-game-filters-category-base";
import {computed} from "mobx";
import {IArenaGameFilter} from "../filters/arena-game-filter.interface";
import {NullableNumber} from "../../../../../common/types/nullable-types";

export class StaticArenaGameFiltersCategory extends ArenaGameFiltersCategoryBase {

    /**
     * Restrict available filters to only those that are defined in config.json for current arena
     */
    @computed
    get availableFilters(): IArenaGameFilter[] {
        return this._createFiltersForCurrentArena();
    }
    private _createFiltersForCurrentArena(): IArenaGameFilter[] {

        const currentArenaFiltersConfigurations = this.services.arenas.getCurrentArena().filtersConfigurationMap;
        if(Check.isEmpty(currentArenaFiltersConfigurations)) {
            return [];
        }

        return this.categoryDefinition.availableFilters
                                      .filter(f => currentArenaFiltersConfigurations[f.id])
                                      .map(f => new StaticArenaGameFilter(f, this.services));
    }

    get gamesCount(): NullableNumber {
        return null;
    }
}